import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { completedComponentState } from '../../stores/completedComponentState';

interface CompleteButtonProps {
  componentId: string;
}

const CompleteButton = (props: CompleteButtonProps) => {
  const [completed, setCompleted] = useRecoilState(completedComponentState(props.componentId));
  const onClick = useCallback(() => {
    setCompleted(true);
  }, [setCompleted]);
  return (
    <div className="ok-button">
      <button type="button" onClick={onClick} disabled={completed}>内容を送信</button>
    </div>
  )
}

export default CompleteButton;
